import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ManagementTemplatesState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: ManagementTemplatesState = {
    managementTemplates: [],
    managementTemplatesItem: undefined,
    managementTemplatesStatus: [1,0],
};


export const managementTemplates: Module<ManagementTemplatesState,RootState> = {
    state,
    getters,
    actions,
    mutations
};
